import { queryClient } from '../api/queryClient'
import { queryKeys } from '../api/queryKeys'
import type {
  VirtualMeterCreateErrorEvent,
  VirtualMeterCreatedEvent,
  VirtualMeterUpdateErrorEvent,
  VirtualMeterUpdatedEvent,
} from '../api/types/generated-types'
import { useVirtualMetersLoadingStore } from '../shared/domain/meters/store/virtual-meters-loading-store'
import { useSocketIoListener } from './useSocketIoListener.hook'

export const useVirtualMetersListener = () => {
  const { removeDeviceId } = useVirtualMetersLoadingStore()

  const handleVirtualMeterCreated = (event: VirtualMeterCreatedEvent) => {
    removeDeviceId(event.deviceId)
    queryClient.invalidateQueries({ queryKey: queryKeys.meters.manyByParams.toKey() })
  }

  const handleVirtualMeterUpdated = (event: VirtualMeterUpdatedEvent) => {
    removeDeviceId(event.deviceId)
    queryClient.invalidateQueries({ queryKey: queryKeys.meters.manyByParams.toKey() })
  }

  const handleVirtualMeterCreateError = (event: VirtualMeterCreateErrorEvent) => {
    removeDeviceId(event.deviceId)
    console.error('Virtual meter creation failed:', event.deviceId, event.errorMessage)
  }

  const handleVirtualMeterUpdateError = (event: VirtualMeterUpdateErrorEvent) => {
    removeDeviceId(event.deviceId)
    console.error('Virtual meter update failed:', event.deviceId, event.errorMessage)
  }

  useSocketIoListener('virtualMeter.meterCreated', handleVirtualMeterCreated)
  useSocketIoListener('virtualMeter.meterUpdated', handleVirtualMeterUpdated)
  useSocketIoListener('virtualMeter.meterCreateError', handleVirtualMeterCreateError)
  useSocketIoListener('virtualMeter.meterUpdateError', handleVirtualMeterUpdateError)
}
